// extracted by mini-css-extract-plugin
export default {"buttons":"checboxPick_buttons__ma4mc"};